// reconstructed from extranet
const Waypoint = window.Waypoint;

addEventListener('DOMContentLoaded', () => {
  const goTop = document.getElementsByClassName('go-top');
  const goTopTrigger = document.getElementsByClassName('go-top-trigger');

  if (goTop.length > 0) {
    goTop[0].addEventListener('click', (e) => {
      e.preventDefault();

      scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    if (document.body.scrollHeight <= document.body.clientHeight) {
      new Waypoint({
        element: goTopTrigger[0],
        offset: '100%',
        handler: () => {
          goTop[0].classList.toggle('show');
        },
      });
    }
  }
});
